import { V2BannerCreateRequestDtoPositionsItem as PositionsItem } from "@everon-it/api-client/contents-gw";
import CustomCheckBox, { type BasicOptionType } from "@components/atoms/CheckBox";
import { InputContentsWrap, InputWrap, Label, LabelInnerWrap, LabelWrap } from "@pages/BannerCreate";
import { findUncommonElements } from "@utils/data-fns";
import { type CheckboxValueType } from "antd/lib/checkbox/Group";
import { type FormikContextType } from "formik";
import { useMemo } from "react";

const ALL_POSITION_ITEMS = [PositionsItem.MAIN, PositionsItem.PREPAID, PositionsItem.GIFT];

const checkHasAllItems = (items: CheckboxValueType[]) => ALL_POSITION_ITEMS.every(item => items.includes(item));

type RenderBannerExposureLocationCheckboxProps<T extends Record<string, unknown>> = {
    formik: FormikContextType<T>;
    name: string;
    checkBoxOptions: BasicOptionType[];
    label: string;
};

const RenderBannerExposureLocationCheckbox = <T extends Record<string, unknown>>({ label, formik, name, checkBoxOptions }: RenderBannerExposureLocationCheckboxProps<T>) => {
    // 전체 분류가 모두 선택되어 있으면 ALL도 체크 표시
    const displayItems = useMemo((): CheckboxValueType[] => {
        const rawValue = formik.values[name];
        const selectItems: CheckboxValueType[] = Array.isArray(rawValue) ? rawValue : [];
        return checkHasAllItems(selectItems) ? [...selectItems, "ALL"] : selectItems;
    }, [formik.values, name]);

    return (
        <InputWrap>
            <LabelWrap>
                <LabelInnerWrap>
                    <Label>{label}</Label>
                </LabelInnerWrap>
            </LabelWrap>
            <InputContentsWrap>
                <CustomCheckBox
                    selectItems={displayItems}
                    options={checkBoxOptions}
                    onChange={(checkedValues: CheckboxValueType[]) => {
                        const clickedItem = findUncommonElements(displayItems, checkedValues);
                        const clickedAll = clickedItem[0] === "ALL";

                        // ALL 클릭: 전체 선택/해제, 개별 클릭: ALL 제외하고 저장
                        const setItems = clickedAll ? (checkHasAllItems(checkedValues) ? [] : [...ALL_POSITION_ITEMS]) : checkedValues.filter(item => item !== "ALL");

                        formik.setFieldValue(name, setItems);
                    }}
                />
            </InputContentsWrap>
        </InputWrap>
    );
};

export default RenderBannerExposureLocationCheckbox;
